<template>
  <v-container fluid class="index-panelV2">
    <schedule-daily-load 
      :dateSchedule="pickTime(1).date" 
      :dateDailyLoad="pickTime(2).date"
      @update-step="updateStep" 
      :step="step"/>
    <contactability
      @update-step.once="updateStep"
      :step="step"/>
    <channels
      :dateCustomer="pickTime(3).date"
      :dateNotification="pickTime(4).date"
      :dateMCustomer="pickTime(5).date"
      :dateMNotification="pickTime(6).date"
      @update-step="updateStep"
      :step="step"/>
  </v-container>
</template>
<script>
import moment from 'moment';
import EventBus from '@/event-bus';
import Channels from './Channels/Index';
import Contactability from './Contactability/Index';
import ScheduleDailyLoad from './ScheduleDaily/Index';

export default {
  created() {
    this.$store.dispatch('INITIALIZE_CHART').then(() => {
      this.step = 1;
    });
  },
  beforeDestroy() {
    window.Echo.leave('workers');
  },
  mounted() {
    window.Echo.private('workers')
      .listen('.lastSyncUpdate', (event) => {
        this.changeTime(event);
      });
    EventBus.$emit('hideMenu');
    this.refreshTime();
  },
  components: {
    ScheduleDailyLoad,
    Contactability,
    Channels,
  },
  data() {
    return {
      change: false,
      step: 0,
      times: [],
    };
  },
  methods: {
    changeTime(time) {
      const chat = this.times.find(x => x.type === Number(time.type));
      chat.date = moment.utc(time.date).local().format('DD/MM/YYYY hh:mm a') || 'No posee';
    },
    refreshTime() {
      this.axios.get('refresh/time/dashboard').then((res) => {
        for (let i = 0; i < 6; i += 1) {
          const data = res.data.find(x => x.type === i + 1) || {};
          if (data.type) {
            this.$set(this.times, i, {
              date: moment.utc(data.date).local().format('DD/MM/YYYY hh:mm a') || 'No posee',
              type: data.type,
            });
          } else {
            const obj = {
              date: 'No posee',
              type: i + 1,
            };
            this.$set(this.times, i, obj);
          }
        }
      }).catch(() => {});
    },
    updateStep(value) {
      if (value > this.step || value === 4) {
        this.step = value;
      }
    },
    pickTime(id) {
      return this.times.find(x => x.type === id) || {};
    },
  },
};
</script>
<style scoped>
.index-panelV2 >>> .font-weight-thin {
  font-weight: 300;
}
.index-panelV2 >>> .font-weight-light {
  font-weight: 400;
}
.index-panelV2 >>> .caption.font-weight-thin {
  font-size: 10px !important;
}
.index-panelV2 >>> .btn-total-load {
  position: absolute;
  right: 1vw;
  width: 9vw;
  bottom: 0;
}
.index-panelV2 >>> .btn-total-load label {
    color: #000 !important;
    font-weight: inherit;
}
</style>





// WEBPACK FOOTER //
// src/components/panelV2/Index.vue